import request from '@/utils/request'
const apiPath = '/cust/customer/tee'
const areaExportApi = {
  /**
   * 大区导出【页面初始化信息】
   * 返回当前登录账号绑定的大区，以及可导出的客户身份
   */
  fetchInfo() {
    return request.get(`${apiPath}/areaExportInfo`)
  },
  /**
   * 导出【大区管辖客户】
   */
  exportExcel(query) {
    return request.get(`${apiPath}/exportForArea`, { params: query })
  }
}
export default areaExportApi
